<template>
  <section>
    <div class="table_top_div" style="padding-top: 0">
      <el-tabs style="width: 100%; font-size: 12px" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="日耗用量整体分析" name="1">
          <el-row style="margin-top: 10px" :type="isMobile ? 'flex' : 'flex'" :gutter="1" justify="space-around">
            <el-col :span="5" :xs="6">
              <el-card style="background-color: #024c6f" :class="isMobile ? 'card_cls card_cls_mb' : 'card_cls'" shadow="hover">
                <div :style="{ color: '#def3fd', 'margin-bottom': '5px', 'font-size': isMobile ? '12px' : '24px' }">
                  {{ currency(summary.ytdTargetVolume) }}
                </div>
                <div :style="{ color: '#def3fd', 'font-size': isMobile ? '8px' : '' }">YTD 指标</div>
              </el-card>
            </el-col>
            <el-col :span="5" :xs="6">
              <el-card style="background-color: #024c6f" :class="isMobile ? 'card_cls card_cls_mb' : 'card_cls'" shadow="hover">
                <div :style="{ color: '#def3fd', 'margin-bottom': '5px', 'font-size': isMobile ? '12px' : '24px' }">
                  {{ currency(summary.ytdActualVolume) }}
                </div>
                <div :style="{ color: '#def3fd', 'font-size': isMobile ? '8px' : '' }">YTD 日耗用量</div>
              </el-card>
            </el-col>
            <el-col :span="5" :xs="6">
              <el-card style="background-color: #024c6f" :class="isMobile ? 'card_cls card_cls_mb' : 'card_cls'" shadow="hover">
                <div :style="{ color: '#def3fd', 'margin-bottom': '5px', 'font-size': isMobile ? '12px' : '24px' }">
                  {{ Number(summary.ytdAchievementRate * 100).toFixed(0) + '%' }}
                </div>
                <div :style="{ color: '#def3fd', 'font-size': isMobile ? '8px' : '' }">YTD 日耗用量达成</div>
              </el-card>
            </el-col>
            <el-col :span="5" :xs="6">
              <el-card style="background-color: #024c6f" :class="isMobile ? 'card_cls card_cls_mb' : 'card_cls'" shadow="hover">
                <div :style="{ color: '#def3fd', 'margin-bottom': '5px', 'font-size': isMobile ? '12px' : '24px' }">
                  {{ Number(summary.ytdGrowthRate * 100).toFixed(0) + '%' }}
                </div>
                <div :style="{ color: '#def3fd', 'font-size': isMobile ? '8px' : '' }">YTD 日耗用量增长</div>
              </el-card>
            </el-col>
          </el-row>
          <reprot_forms
            style="margin: 10px 0"
            :area_list="area_list"
            :product_List="product_List"
            :roleName_list="roleName_list"
            v-if="activeName == '1'"
            :activeName="activeName"
            @getReportData="getReportData"
          ></reprot_forms>
          <el-row>
            <!-- :gutter="20" style="overflow-x: auto" -->
            <el-col :span="12" :xs="24" :style="ytd_widths == '1500px' || isMobile ? 'overflow-x: auto' : ''">
              <div ref="chartContainer" class="chart_div"></div>
            </el-col>
            <el-col :span="12" :xs="24" :style="isMobile ? 'overflow-x: auto' : ''"><div ref="chartContainer2" class="chart_div"></div></el-col>
          </el-row>
          <el-row :style="{ color: '#def3fd', 'margin-top': isMobile ? '0' : '10px' }">
            <el-col :style="isMobile ? 'overflow-x: auto' : ''" :span="12" :xs="24"><div ref="chartContainer3" class="chart_div"></div></el-col>
            <el-col :style="isMobile ? 'overflow-x: auto' : ''" :span="12" :xs="24">
              <div ref="chartContainer4" class="chart_div"></div>
              <div style="color: black; font-size: 8px; text-align: center">
                Synergy Family：ZFR00v/DFW Symfony Family:ZXR/ZXT Eyhance Family: ICB/DIB
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="日耗用量月度分析" name="2">
          <el-row style="margin-top: 10px" :type="isMobile ? '' : 'flex'" :gutter="1" justify="space-around">
            <el-col :span="4" :xs="6">
              <el-card style="background-color: #024c6f" :class="isMobile ? 'card_cls card_cls_mb' : 'card_cls'" shadow="hover">
                <div :style="{ color: '#def3fd', 'margin-bottom': '5px', 'font-size': isMobile ? '12px' : '24px' }">
                  {{ currency(summary_mtd.mtdTargetVolume) }}
                </div>
                <div :style="{ color: '#def3fd', 'font-size': isMobile ? '8px' : '' }">MTD 指标</div>
              </el-card>
            </el-col>
            <el-col :span="4" :xs="6">
              <el-card style="background-color: #024c6f" :class="isMobile ? 'card_cls card_cls_mb' : 'card_cls'" shadow="hover">
                <div :style="{ color: '#def3fd', 'margin-bottom': '5px', 'font-size': isMobile ? '12px' : '24px' }">
                  {{ currency(summary_mtd.mtdActualVolume) }}
                </div>
                <div :style="{ color: '#def3fd', 'font-size': isMobile ? '8px' : '' }">MTD 日耗用量</div>
              </el-card>
            </el-col>
            <el-col :span="4" :xs="6">
              <el-card style="background-color: #024c6f" :class="isMobile ? 'card_cls card_cls_mb' : 'card_cls'" shadow="hover">
                <div :style="{ color: '#def3fd', 'margin-bottom': '5px', 'font-size': isMobile ? '12px' : '24px' }">
                  {{ Number(summary_mtd.mtdAchievementRate * 100).toFixed(0) + '%' }}
                </div>
                <div :style="{ color: '#def3fd', 'font-size': isMobile ? '8px' : '' }">MTD 日耗用量达成</div>
              </el-card>
            </el-col>
            <el-col :span="4" :xs="6">
              <el-card style="background-color: #024c6f" :class="isMobile ? 'card_cls card_cls_mb' : 'card_cls'" shadow="hover">
                <div :style="{ color: '#def3fd', 'margin-bottom': '5px', 'font-size': isMobile ? '12px' : '24px' }">
                  {{ Number(summary_mtd.mtdGrowthRate * 100).toFixed(0) + '%' }}
                </div>
                <div :style="{ color: '#def3fd', 'font-size': isMobile ? '8px' : '' }">MTD 日耗用量增长</div>
              </el-card>
            </el-col>
            <el-col :span="4" :xs="6">
              <el-card style="background-color: #024c6f" :class="isMobile ? 'card_cls card_cls_mb' : 'card_cls'" shadow="hover">
                <div :style="{ color: '#def3fd', 'margin-bottom': '5px', 'font-size': isMobile ? '12px' : '24px' }">
                  {{ currency(summary_mtd.mtdDailyPeopleCount) }}
                </div>
                <div :style="{ color: '#def3fd', 'font-size': isMobile ? '8px' : '' }">MTD 日均填报人数</div>
              </el-card>
            </el-col>
            <el-col :span="4" :xs="6">
              <el-card style="background-color: #024c6f" :class="isMobile ? 'card_cls card_cls_mb' : 'card_cls'" shadow="hover">
                <div :style="{ color: '#def3fd', 'margin-bottom': '5px', 'font-size': isMobile ? '12px' : '24px' }">
                  {{ Number(summary_mtd.mtdDailyFillRate * 100).toFixed(0) + '%' }}
                </div>
                <div :style="{ color: '#def3fd', 'font-size': isMobile ? '8px' : '' }">MTD 日均填报率</div>
              </el-card>
            </el-col>
            <el-col :span="4" :xs="6">
              <el-card style="background-color: #024c6f" :class="isMobile ? 'card_cls card_cls_mb' : 'card_cls'" shadow="hover">
                <div :style="{ color: '#def3fd', 'margin-bottom': '5px', 'font-size': isMobile ? '12px' : '24px' }">
                  {{ Number(summary_mtd.mtdTimeProgress * 100).toFixed(0) + '%' }}
                </div>
                <div :style="{ color: '#def3fd', 'font-size': isMobile ? '8px' : '' }">MTD 时间进度</div>
              </el-card>
            </el-col>
            <el-col :span="4" :xs="6">
              <el-card style="background-color: #024c6f" :class="isMobile ? 'card_cls card_cls_mb' : 'card_cls'" shadow="hover">
                <div :style="{ color: '#def3fd', 'margin-bottom': '5px', 'font-size': isMobile ? '12px' : '24px' }">
                  {{ Number(summary_mtd.mtdTargetProgress * 100).toFixed(0) + '%' }}
                </div>
                <div :style="{ color: '#def3fd', 'font-size': isMobile ? '8px' : '' }">MTD 指标完成进度</div>
              </el-card>
            </el-col>
          </el-row>
          <reprot_forms
            style="margin: 10px 0"
            :area_list="area_list"
            :product_List="product_List"
            :roleName_list="roleName_list"
            v-if="activeName == '2'"
            :activeName="activeName"
            @getReportData="getReportData"
          ></reprot_forms>
          <el-row>
            <el-col :span="12" :xs="24" :style="mtd_widths == '1500px' || isMobile ? 'overflow-x: auto' : ''">
              <div ref="chartContainer_mtd" class="chart_div"></div>
            </el-col>
            <el-col :span="12" :xs="24" :style="isMobile ? 'overflow-x: auto' : ''"><div ref="chartContainer2_mtd" class="chart_div"></div></el-col>
          </el-row>
          <el-row :style="{ color: '#def3fd', 'margin-top': isMobile ? '0' : '10px' }">
            <el-col :span="24" :xs="24" :style="isMobile ? 'overflow-x: auto' : ''">
              <div ref="chartContainer3_mtd" class="chart_div"></div>
              <div style="color: black; font-size: 8px; text-align: center">
                Synergy Family：ZFR00v/DFW Symfony Family:ZXR/ZXT Eyhance Family: ICB/DIB
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="日耗用量每日分析" name="3">
          <el-row style="margin-top: 10px" :type="isMobile ? 'flex' : 'flex'" :gutter="1" justify="space-around">
            <el-col :span="4" :xs="8">
              <el-card style="background-color: #024c6f" :class="isMobile ? 'card_cls card_cls_mb' : 'card_cls'" shadow="hover">
                <div :style="{ color: '#def3fd', 'margin-bottom': '5px', 'font-size': isMobile ? '12px' : '24px' }">
                  {{ currency(summary_day.dailyTargetCount) }}
                </div>
                <div :style="{ color: '#def3fd', 'font-size': isMobile ? '8px' : '' }">指标</div>
              </el-card>
            </el-col>
            <el-col :span="4" :xs="8">
              <el-card style="background-color: #024c6f" :class="isMobile ? 'card_cls card_cls_mb' : 'card_cls'" shadow="hover">
                <div :style="{ color: '#def3fd', 'margin-bottom': '5px', 'font-size': isMobile ? '12px' : '24px' }">
                  {{ currency(summary_day.dailyUsageCount) }}
                </div>
                <div :style="{ color: '#def3fd', 'font-size': isMobile ? '8px' : '' }">耗用量</div>
              </el-card>
            </el-col>
            <el-col :span="4" :xs="8">
              <el-card style="background-color: #024c6f" :class="isMobile ? 'card_cls card_cls_mb' : 'card_cls'" shadow="hover">
                <div :style="{ color: '#def3fd', 'margin-bottom': '5px', 'font-size': isMobile ? '12px' : '24px' }">
                  {{ Number(summary_day.dailyAchievementRate * 100).toFixed(0) + '%' }}
                </div>
                <div :style="{ color: '#def3fd', 'font-size': isMobile ? '8px' : '' }">耗用量达成</div>
              </el-card>
            </el-col>
            <el-col v-show="!roleName_list.includes('一线销售')" :span="4" :xs="8">
              <el-card style="background-color: #024c6f" :class="isMobile ? 'card_cls card_cls_mb' : 'card_cls'" shadow="hover">
                <div :style="{ color: '#def3fd', 'margin-bottom': '5px', 'font-size': isMobile ? '12px' : '24px' }">
                  {{ currency(summary_day.dailyReporterCount) }}
                </div>
                <div :style="{ color: '#def3fd', 'font-size': isMobile ? '8px' : '' }">日均填报人数</div>
              </el-card>
            </el-col>
            <el-col v-show="!roleName_list.includes('一线销售')" :span="4" :xs="8">
              <el-card style="background-color: #024c6f" :class="isMobile ? 'card_cls card_cls_mb' : 'card_cls'" shadow="hover">
                <div :style="{ color: '#def3fd', 'margin-bottom': '5px', 'font-size': isMobile ? '12px' : '24px' }">
                  {{ Number(summary_day.dailyFillRate * 100).toFixed(0) + '%' }}
                </div>
                <div :style="{ color: '#def3fd', 'font-size': isMobile ? '8px' : '' }">日均填报率</div>
              </el-card>
            </el-col>
          </el-row>
          <reprot_forms
            style="margin: 10px 0"
            :area_list="area_list"
            :product_List="product_List"
            :roleName_list="roleName_list"
            v-if="activeName == '3'"
            :activeName="activeName"
            @getReportData="getReportData"
          ></reprot_forms>
          <el-row>
            <el-col :span="12" :xs="24" :style="day_widths == '1500px' || isMobile ? 'overflow-x: auto' : ''">
              <div ref="chartContainer_day" class="chart_div"></div>
            </el-col>
            <el-col :span="12" :xs="24" :style="isMobile ? 'overflow-x: auto' : ''"><div ref="chartContainer2_day" class="chart_div"></div></el-col>
          </el-row>
          <el-row
            v-show="!roleName_list.includes('小区经理') && !roleName_list.includes('大区经理') && !roleName_list.includes('一线销售')"
            :style="{ color: '#def3fd', 'margin-top': isMobile ? '0' : '10px' }"
          >
            <el-col :span="24" :xs="24" :style="isMobile ? 'overflow-x: auto' : ''">
              <div ref="chartContainer3_day" class="chart_div"></div>
            </el-col>
            <!-- <el-col :span="24"> -->
            <el-table
              border
              width="100%"
              :show-header="false"
              :data="subRegionPerformance_list"
              class="reports"
              header-cell-class-name="header_cell_name"
              :cell-style="{ 'text-align': 'center' }"
              highlight-current-row
              style="white-space: inherit"
            >
              <el-table-column
                :min-width="isMobile ? '50' : '10%'"
                v-for="(item, index) in subRegionPerformance_getIHeaders"
                :key="index"
                :prop="item"
                align="center"
              >
                <template slot-scope="scope">{{ scope.row[item] }}</template>
              </el-table-column>
            </el-table>
            <p v-if="this.isMobile" style="color: red; padding: 0; margin: 0">&lt&lt&lt向左滑动查看更多</p>
            <!-- </el-col> -->
            <!-- <el-col :span="12"><div ref="chartContainer4" class="chart_div"></div></el-col> -->
          </el-row>
        </el-tab-pane>
      </el-tabs>
      <p style="color: #8d8f90; text-align: right; font-size: 10px">*数据仅供内部使用，请勿外传，实际业绩达成请参考销售业绩报告</p>
    </div>
  </section>
</template>

<script>
import { calculateSum, loadings } from '@/utils'
import {
  usagereport_getytdusage_ytd,
  usagereport_getregionsbylevel,
  usagereport_getytdusage_mtd,
  usagereport_getdailyusage_day,
  system_getproductlistothers,
  extapi_dashboard_get,
} from '@/api/api'
import { getButtonList } from '../../promissionRouter'
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import Toolbar from '../../components/Toolbar'
import * as echarts from 'echarts'
import reprot_forms from './data_report_new_queryForms'
export default {
  components: { Toolbar, quillEditor, reprot_forms },
  computed: {
    style_tbs() {
      return {
        width: this.isMobile ? '1200px' : '100%',
        height: '400px',
        display: 'inline-block',
      }
    },
    style_tbs2() {
      return {
        width: this.isMobile ? '800px' : '100%',
        height: '400px',
        display: 'inline-block',
      }
    },
  },
  data() {
    return {
      chart_fontSize: 8,
      day_widths: '100%',
      mtd_widths: '100%',
      ytd_widths: '100%',
      activeName_if: '1',
      subRegionPerformance_getIHeaders: [],
      subRegionPerformance_list: [],
      charts_list: [],
      roleName_list: [],
      filters: {
        StartMonth: '',
        EndMonth: '',
      },
      filters_mtd: {
        Month: '',
      },
      filters_day: {
        Date: '',
      },
      city_list: [],
      area_list: [],
      isMobile: false,
      summary: {},
      summary_mtd: {},
      summary_day: {},
      ytd_list: [],
      activeName: '1',
      product_List: '',
    }
  },
  methods: {
    feature_fn(e) {
      return {
        myFullscreen: {
          show: true,
          title: '全屏',
          icon: 'image://' + require('@/assets/qp.png'), // 自定义SVG路径
          onclick: () => {
            const element = e
            // this.usagereport_getytdusage_ytd_fn()
            if (element.requestFullScreen) {
              element.requestFullScreen()
            } else if (element.msRequestFullscreen) {
              element.msRequestFullScreen()
            } else if (element.webkitRequestFullScreen) {
              element.webkitRequestFullScreen()
            } else if (element.mozRequestFullScreen) {
              element.mozRequestFullScreen()
            }
            // 退出全屏
            if (element.requestFullScreen) {
              document.exitFullscreen()
            } else if (document.msRequestFullScreen) {
              document.msExitFullscreen()
            } else if (element.webkitRequestFullScreen) {
              document.webkitCancelFullScreen()
            } else if (element.mozRequestFullScreen) {
              document.mozCancelFullScreen()
            }
          },
        },
      }
    },
    async extapi_dashboard_get_fn() {
      const {
        data: { data },
      } = await extapi_dashboard_get()
      let new_obj = {}
      let roleName_list = []
      for (var i in data) {
        roleName_list.push(data[i].roleName)
        new_obj = {
          ...data[i].flacsSummarys,
          ...data[i].managerSummary,
          ...data[i].salesSummary,
        }
      }
      this.roleName_list = roleName_list
      this.new_obj = new_obj
    },
    getRegionList(value) {
      const selectedOptions = this.area_list.filter((option) => option.regionId === value)
      this.city_list = selectedOptions[0].subRegions
      this.filters.city = ''
    },
    async dashboard_getregionsbylevel() {
      const { data } = await usagereport_getregionsbylevel()
      this.area_list = data.data.regions
    },
    currency(val) {
      if (val == '' || val == null) {
        return val
      }
      if (Number(val) == 0) {
        return 0
      }
      let precision = 0
      let decimal = this.checkNaN(val, (v) => v.toFixed(precision))
      const [n, d = []] = decimal.toString().split('.')
      return [n.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')].concat(d).join('.')
    },
    checkNaN(value, cb) {
      const val = parseFloat(value)
      return isNaN(val) ? undefined : cb(val)
    },

    async usagereport_getytdusage_ytd_fn() {
      loadings()
      const { data } = await usagereport_getytdusage_ytd(this.filters)
      this.usagereport_getytdusage_ytd_details = data
      this.summary = data.summary
      this.initChart()
      this.initChart2()
      this.initChart3()
      this.initChart4()
      loadings(0)
    },
    async usagereport_getytdusage_mtd_fn() {
      loadings()
      const { data } = await usagereport_getytdusage_mtd(this.filters_mtd)
      this.usagereport_getytdusage_mtd_details = data
      this.summary_mtd = data.summary
      this.initChart_mtd()
      this.initChart_mtd2()
      this.initChart_mtd3()
      loadings(0)
    },
    async usagereport_getdailyusage_day_fn() {
      loadings()
      const { data } = await usagereport_getdailyusage_day(this.filters_day)
      this.summary_day = data.summary
      let datasa = data.subRegionPerformance
      const iHeaders = [
        {
          prop: 'subRegionName',
          label: '',
        },
        {
          prop: 'target',
          label: '指标',
        },
        {
          prop: 'dailyUsage',
          label: '日耗用量',
        },
        {
          prop: 'achievementRate',
          label: '达成率',
        },
      ]
      const getIHeaders = datasa.subRegionPerformance.reduce((pre, cur, index) => pre.concat(`value${index}`), ['title'])

      const getIValues = iHeaders.map((item) => {
        return datasa.subRegionPerformance.reduce(
          (pre, cur, index) =>
            Object.assign(pre, {
              ['value' + index]:
                item.prop == 'achievementRate'
                  ? (cur[item.prop] * 100).toFixed(0) + '%'
                  : item.prop == 'target' || item.prop == 'dailyUsage'
                  ? this.currency(cur[item.prop])
                  : cur[item.prop],
            }),
          {
            title: item.label,
          }
        )
      })
      this.subRegionPerformance_list = getIValues
      this.subRegionPerformance_getIHeaders = getIHeaders
      this.usagereport_getdailyusage_day_details = data
      this.initChart_day()
      this.initChart_day2()
      this.initChart_day3()
      loadings(0)
    },
    initChart_day(res) {
      var res = this.usagereport_getdailyusage_day_details.regionPerformance
      const regions = res.regionPerformance.map((item) => item.regionName)
      this.day_widths = regions.length > 6 ? '1500px' : '100%'
      if (this.isMobile) {
        if (regions.length > 6) {
          this.day_widths = '1500px'
        } else {
          this.day_widths = '600px'
        }
      } else {
        this.day_widths = regions.length > 6 ? '1500px' : '100%'
      }
      this.$refs.chartContainer_day.style.width = this.day_widths
      // 初始化图表
      let chart = echarts.init(this.$refs.chartContainer_day)
      this.charts_list.push(chart)
      const legends = ['指标', '日耗用量', '达成率']
      //   今年
      const thisYearData = res.regionPerformance.map((item) => item.thisYear)
      //   去年
      const dailyUsage = res.regionPerformance.map((item) => item.dailyUsage)
      //   指标
      const target = res.regionPerformance.map((item) => item.target)
      //   完成率
      const achievementRates = res.regionPerformance.map((item) => item.achievementRate * 100)
      //   增长率
      const growthRates = res.regionPerformance.map((item) => item.growthRate * 100)

      const MathachievementRates = Math.max(...achievementRates)
      const averageAchieveRate = (res.averageAchieveRate * 100).toFixed(0)
      const maxValue = MathachievementRates > averageAchieveRate ? null : averageAchieveRate
      //   设置series
      let series_list = legends.map((name) => {
        // return {
        //   name: name,
        //   type: 'bar',
        //   itemStyle: itemStyle_cls,
        //   data: res.map((d, did) => {
        //     return d.data[sid].accuracyPercentage
        //   }),
        // }
      })
      let by_region = ''
      // 配置项
      const option = {
        toolbox: {
          show: this.isMobile ? false : true, // 是否显示工具栏
          orient: 'horizontal', // 工具栏布局方向
          itemSize: 15, // 工具栏图标大小
          itemGap: 10, // 工具栏图标间隔
          right: 20, // 工具栏距离右侧的距离
          top: 5, // 工具栏距离顶部的距离
          feature: this.feature_fn(this.$refs.chartContainer_day), //封装全屏方法
        },
        title: {
          text: '日耗用量达成',
          //   left: 'left',
          textStyle: {
            fontSize: window.innerWidth > 768 ? 14 : 14, // 桌面端16px，移动端14px
          },
          top: 5,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'cross' },
          formatter: (params) => {
            let res = `${params[0].name}<br>`
            params.forEach((p) => {
              let value
              if (p.seriesType === 'line') {
                value = `${p.value.toLocaleString(undefined, { maximumFractionDigits: 1 })}%`
              } else {
                value = p.value.toLocaleString()
              }
              res += `${p.marker} ${p.seriesName}: ${value}<br>`
            })
            return res
          },
        },
        legend: {
          data: legends,
          itemWidth: 8, // 缩小图例标记尺寸
          itemHeight: 8,
          textStyle: {
            fontSize: this.chart_fontSize,
          },
          bottom: 0,
        },
        grid: {
          top: 50, // 图表主体在标题+图例下方
          bottom: 30,
          left: 10,
          right: 20,
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: regions,
            axisPointer: {
              type: 'shadow',
            },
            axisLabel: {
              formatter: (value) => this.isCh(value, 12),
              tooltip: {
                show: true,
                formatter: (params) => params.value, // 悬停显示完整内容
              },
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: '',
            // min: 0,
            // max: 200,
            axisLabel: {
              formatter: (value) => {
                // 核心格式化函数
                if (value >= 1000) {
                  const kValue = value / 1000
                  // 处理小数位显示逻辑
                  return Number.isInteger(kValue) ? `${kValue.toLocaleString()}k` : `${kValue.toFixed(1).toLocaleString()}k`
                }
                return value
              },
            },
          },
          {
            type: 'value',
            name: '',
            // min: 0,
            max: maxValue,
            axisLabel: {
              formatter: '{value} %',
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: '指标',
            type: 'bar',
            data: target,
            itemStyle: {
              color: '#051C20',
            },
            barWidth: '30%',
            label: {
              show: true,
              position: 'top',
              formatter: (params) => {
                return params.value.toLocaleString()
              },
              color: '#333',
              fontSize: this.chart_fontSize,
            },
          },
          {
            name: '日耗用量',
            type: 'bar',
            data: dailyUsage,
            itemStyle: {
              color: '#00a8f3',
            },
            barWidth: '30%',
            label: {
              show: true,
              position: 'top',
              formatter: (params) => params.value.toLocaleString(), // 千分位格式化
              color: '#333',
              fontSize: this.chart_fontSize,
            },
          },
          {
            name: '达成率',
            type: 'line',
            yAxisIndex: 1,
            data: achievementRates,
            itemStyle: {
              color: '#027ab0',
            },
            markLine: {
              symbol: 'none',
              label: {
                position: 'insideStartTop',
                formatter: '大区平均:{c}%',
                color: '#ff0000',
                fontSize: this.chart_fontSize,
                fontWeight: 'bold',
                distance: [-25, 0],
                // verticalAlign: 'bottom',
              },
              lineStyle: {
                color: '#FF6B6B',
                width: 2,
              },
              data: [
                {
                  yAxis: averageAchieveRate,
                  name: '平均值',
                },
              ],
            },
            smooth: false,
            symbol: 'circle',
            symbolSize: 8,
            lineStyle: {
              width: 3,
              type: 'dashed',
            },
            label: {
              show: true,
              position: 'top',
              formatter: (params) => {
                return `${params.value.toLocaleString()}%`
              },
              //   color: '#00a9f4',
              fontWeight: 'bold',
              fontSize: this.chart_fontSize,
            },
          },
        ],
      }

      // 设置配置项
      chart.setOption(option, true)
      chart.resize()
    },
    initChart_day2(res) {
      var res = this.usagereport_getdailyusage_day_details
      // 初始化图表
      if (this.isMobile) {
        this.$refs.chartContainer2_day.style.width = '600px'
      }
      let chart = echarts.init(this.$refs.chartContainer2_day)
      this.charts_list.push(chart)
      const legends = ['指标', '日耗用量', '达成率']
      const regions = res.productPerformance.map((item) => item.productName)
      //   去年
      const dailyUsage = res.productPerformance.map((item) => item.dailyUsage)
      //   指标
      const target = res.productPerformance.map((item) => item.target)
      //   完成率
      const achievementRates = res.productPerformance.map((item) => item.achievementRate * 100)
      //   设置series
      let series_list = legends.map((name) => {
        // return {
        //   name: name,
        //   type: 'bar',
        //   itemStyle: itemStyle_cls,
        //   data: res.map((d, did) => {
        //     return d.data[sid].accuracyPercentage
        //   }),
        // }
      })
      // 配置项
      const option = {
        toolbox: {
          show: this.isMobile ? false : true, // 是否显示工具栏
          orient: 'horizontal', // 工具栏布局方向
          itemSize: 15, // 工具栏图标大小
          itemGap: 10, // 工具栏图标间隔
          right: 20, // 工具栏距离右侧的距离
          top: 5, // 工具栏距离顶部的距离
          feature: this.feature_fn(this.$refs.chartContainer2_day),
        },
        title: {
          text: '各品类日耗用量达成',
          //   left: 'left',
          textStyle: {
            fontSize: window.innerWidth > 768 ? 14 : 14, // 桌面端16px，移动端14px
          },
          top: 5,
        },
        // dataZoom: [
        //   {
        //     type: 'slider',
        //     show: true,
        //     // xAxisIndex: [0],
        //     start: 0,
        //     end: 100,
        //     height: 10, // 组件高度
        //     bottom: 10,
        //   },
        //   {
        //     type: 'inside', // 内置型数据缩放
        //     zoomLock: true, // 锁定缩放比例
        //     zoomOnMouseWheel: 'shift', // 按住shift滚轮缩放
        //   },
        // ],
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'cross' },
          formatter: (params) => {
            let res = `${params[0].name}<br>`
            params.forEach((p) => {
              let value
              if (p.seriesType === 'line') {
                value = `${p.value.toLocaleString(undefined, { maximumFractionDigits: 1 })}%`
              } else {
                value = p.value.toLocaleString()
              }
              res += `${p.marker} ${p.seriesName}: ${value}<br>`
            })
            return res
          },
        },
        legend: {
          data: legends,
          itemWidth: 8, // 缩小图例标记尺寸
          itemHeight: 8,
          textStyle: {
            fontSize: this.chart_fontSize,
          },
          bottom: 0,
        },
        grid: {
          top: 50, // 图表主体在标题+图例下方
          bottom: 30,
          left: 10,
          right: 20,
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: regions,
            axisPointer: {
              type: 'shadow',
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: '',
            // min: 0,
            // max: 200,
            axisLabel: {
              formatter: (value) => {
                // 核心格式化函数
                if (value >= 1000) {
                  const kValue = value / 1000
                  // 处理小数位显示逻辑
                  return Number.isInteger(kValue) ? `${kValue.toLocaleString()}k` : `${kValue.toFixed(1).toLocaleString()}k`
                }
                return value
              },
            },
          },
          {
            type: 'value',
            name: '',
            // min: 0,
            // max: 100,
            axisLabel: {
              formatter: '{value} %',
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: '指标',
            type: 'bar',
            data: target,
            itemStyle: {
              color: '#051C20',
            },
            barWidth: '30%',
            label: {
              show: true,
              position: 'top',
              formatter: (params) => {
                return params.value.toLocaleString()
              },

              color: '#333',
              fontSize: this.chart_fontSize,
            },
          },
          {
            name: '日耗用量',
            type: 'bar',
            data: dailyUsage,
            itemStyle: {
              color: '#00a8f3',
            },
            barWidth: '30%',
            label: {
              show: true,
              position: 'top',
              formatter: (params) => params.value.toLocaleString(), // 千分位格式化
              color: '#333',
              fontSize: this.chart_fontSize,
            },
          },
          {
            name: '达成率',
            type: 'line',
            yAxisIndex: 1,
            data: achievementRates,
            itemStyle: {
              color: '#027ab0',
            },
            smooth: false,
            symbol: 'circle',
            symbolSize: 8,
            lineStyle: {
              width: 3,
              type: 'dashed',
            },
            label: {
              show: true,
              position: 'top',
              formatter: (params) => {
                return `${params.value.toLocaleString()}%`
              },
              //   color: '#00a9f4',
              fontWeight: 'bold',
              fontSize: this.chart_fontSize,
            },
          },
        ],
      }

      // 设置配置项
      chart.setOption(option, true)
    },
    initChart_day3(res) {
      var res = this.usagereport_getdailyusage_day_details.subRegionPerformance
      if (this.isMobile) {
        this.$refs.chartContainer3_day.style.width = '600px'
      }
      // 初始化图表
      let chart = echarts.init(this.$refs.chartContainer3_day)
      this.charts_list.push(chart)
      const legends = ['指标', '日耗用量', '达成率']
      const categorys = res.subRegionPerformance.map((item) => item.subRegionName)
      //   指标
      const target = res.subRegionPerformance.map((item) => item.target)
      //   日耗用量
      const dailyUsage = res.subRegionPerformance.map((item) => item.dailyUsage)
      //   完成率
      const achievementRates = res.subRegionPerformance.map((item) => item.achievementRate * 100)

      const MathachievementRates = Math.max(...dailyUsage)
      const averageAchieveRate = res.averageAchieveRate.toFixed(0)
      var maxValue = MathachievementRates > averageAchieveRate ? null : averageAchieveRate
      //   设置series
      let series_list = legends.map((name) => {
        // return {
        //   name: name,
        //   type: 'bar',
        //   itemStyle: itemStyle_cls,
        //   data: res.map((d, did) => {
        //     return d.data[sid].accuracyPercentage
        //   }),
        // }
      })
      // 配置项
      const option = {
        toolbox: {
          show: this.isMobile ? false : true, // 是否显示工具栏
          orient: 'horizontal', // 工具栏布局方向
          itemSize: 15, // 工具栏图标大小
          itemGap: 10, // 工具栏图标间隔
          right: 20, // 工具栏距离右侧的距离
          top: 5, // 工具栏距离顶部的距离
          feature: this.feature_fn(this.$refs.chartContainer3_day),
        },
        title: {
          text: '日耗用量排名',
          //   left: 'left',
          fontSize: this.chart_fontSize,
          textStyle: {
            fontSize: window.innerWidth > 768 ? 14 : 14, // 桌面端16px，移动端14px
          },
          top: 5,
        },
        // dataZoom: [
        //   {
        //     type: 'slider',
        //     show: true,
        //     xAxisIndex: [0],
        //     start: 0,
        //     end: 100,
        //   },
        // ],
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'cross' },
          formatter: (params) => {
            let res = `${params[0].name}<br>`
            params.forEach((p) => {
              let value
              if (p.seriesType === 'line') {
                value = `${p.value.toLocaleString(undefined, { maximumFractionDigits: 1 })}%`
              } else {
                value = p.value.toLocaleString()
              }
              res += `${p.marker} ${p.seriesName}: ${value}<br>`
            })
            return res
          },
        },
        legend: {
          data: legends,
          itemWidth: 8, // 缩小图例标记尺寸
          itemHeight: 8,
          textStyle: {
            fontSize: this.chart_fontSize,
          },
          bottom: 0,
        },
        grid: {
          top: 50, // 图表主体在标题+图例下方
          bottom: 30,
          left: 10,
          right: 20,
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: categorys,
            axisPointer: {
              type: 'shadow',
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: '',
            // min: 0,
            max: maxValue,
            axisLabel: {
              formatter: (value) => {
                // 核心格式化函数
                if (value >= 1000) {
                  const kValue = value / 1000
                  // 处理小数位显示逻辑
                  return Number.isInteger(kValue) ? `${kValue.toLocaleString()}k` : `${kValue.toFixed(1).toLocaleString()}k`
                }
                return value
              },
            },
          },
          {
            type: 'value',
            name: '',
            // min: 0,
            // max: 100,
            axisLabel: {
              formatter: '{value} %',
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: '指标',
            type: 'bar',
            data: target,
            itemStyle: {
              color: '#051C20',
            },
            barWidth: '30%',
            label: {
              show: true,
              position: 'top',
              formatter: (params) => {
                return params.value.toLocaleString()
              },
              color: '#333',
              fontSize: this.chart_fontSize,
            },
          },
          {
            name: '日耗用量',
            type: 'bar',
            data: dailyUsage,
            itemStyle: {
              color: '#00a8f3',
            },
            barWidth: '30%',
            markLine: {
              symbol: 'none',
              label: {
                position: 'insideStartTop',
                color: '#ff0000',
                fontSize: this.chart_fontSize,
                fontWeight: 'bold',
                formatter: (params) => {
                  return '区域平均:' + params.value.toLocaleString()
                },
                distance: [-10, 0],
                // verticalAlign: 'bottom',
              },
              lineStyle: {
                color: '#FF6B6B',
                width: 2,
              },
              data: [
                {
                  yAxis: res.averageAchieveRate.toFixed(0),
                  //   yAxis: 98,
                  name: '平均值',
                },
              ],
            },
            label: {
              show: true,
              position: 'top',
              formatter: (params) => params.value.toLocaleString(), // 千分位格式化
              color: '#333',
              fontSize: this.chart_fontSize,
            },
          },
          {
            name: '达成率',
            type: 'line',
            yAxisIndex: 1,
            data: achievementRates,
            itemStyle: {
              color: '#027ab0',
            },
            smooth: false,
            symbol: 'circle',
            symbolSize: 8,
            lineStyle: {
              width: 3,
              type: 'dashed',
            },
            label: {
              show: true,
              position: 'top',
              formatter: (params) => {
                return `${params.value.toLocaleString()}%`
              },
              //   color: '#00a9f4',
              fontWeight: 'bold',
              fontSize: this.chart_fontSize,
            },
          },
        ],
      }

      // 设置配置项
      chart.setOption(option, true)
    },
    initChart_mtd(res) {
      var res = this.usagereport_getytdusage_mtd_details.regionPerformance
      // 初始化图表
      const regions = res.regionPerformance.map((item) => item.region)
      if (this.isMobile) {
        if (regions.length > 6) {
          this.mtd_widths = '1500px'
        } else {
          this.mtd_widths = '600px'
        }
      } else {
        this.mtd_widths = regions.length > 6 ? '1500px' : '100%'
      }
      this.$refs.chartContainer_mtd.style.width = this.mtd_widths
      let chart = echarts.init(this.$refs.chartContainer_mtd)
      this.charts_list.push(chart)
      const legends = ['指标', '日耗用量', '日耗用量达成', '日耗用量增长', '日耗用量环比']
      //   今年
      const thisYearData = res.regionPerformance.map((item) => item.thisYear)
      //   去年
      const lastYearData = res.regionPerformance.map((item) => item.lastYear)
      //   指标
      const target = res.regionPerformance.map((item) => item.target)
      //   完成率
      const achievementRates = res.regionPerformance.map((item) => item.achievementRate * 100)
      //   增长率
      const growthRates = res.regionPerformance.map((item) => item.growthRate * 100)
      //   环比
      const momGrowthRate = res.regionPerformance.map((item) => item.momGrowthRate * 100)

      const MathachievementRates = Math.max(...achievementRates)
      const averageAchieveRate = (res.averageAchieveRate * 100).toFixed(0)
      const maxValue = MathachievementRates > averageAchieveRate ? null : averageAchieveRate
      //   设置series
      let series_list = legends.map((name) => {
        // return {
        //   name: name,
        //   type: 'bar',
        //   itemStyle: itemStyle_cls,
        //   data: res.map((d, did) => {
        //     return d.data[sid].accuracyPercentage
        //   }),
        // }
      })
      // 配置项
      const option = {
        toolbox: {
          show: this.isMobile ? false : true, // 是否显示工具栏
          orient: 'horizontal', // 工具栏布局方向
          itemSize: 15, // 工具栏图标大小
          itemGap: 10, // 工具栏图标间隔
          right: 20, // 工具栏距离右侧的距离
          top: 5, // 工具栏距离顶部的距离
          feature: this.feature_fn(this.$refs.chartContainer_mtd),
        },
        title: {
          text: '日耗用量达成',
          //   left: 'left',
          textStyle: {
            fontSize: window.innerWidth > 768 ? 14 : 14, // 桌面端16px，移动端14px
          },
          top: 5,
        },
        // dataZoom: [
        //   {
        //     type: 'slider',
        //     show: true,
        //     // xAxisIndex: [0],
        //     start: 0,
        //     end: 100,
        //     height: 10, // 组件高度
        //     bottom: 10,
        //   },
        //   {
        //     type: 'inside', // 内置型数据缩放
        //     zoomLock: true, // 锁定缩放比例
        //     zoomOnMouseWheel: 'shift', // 按住shift滚轮缩放
        //   },
        // ],
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'cross' },
          formatter: (params) => {
            let res = `${params[0].name}<br>`
            params.forEach((p) => {
              let value
              if (p.seriesType === 'line') {
                value = `${p.value.toLocaleString(undefined, { maximumFractionDigits: 1 })}%`
              } else {
                value = p.value.toLocaleString()
              }
              res += `${p.marker} ${p.seriesName}: ${value}<br>`
            })
            return res
          },
        },
        legend: {
          data: legends,
          itemWidth: 8, // 缩小图例标记尺寸
          itemHeight: 8,
          textStyle: {
            fontSize: this.chart_fontSize,
          },
          bottom: 0,
        },
        grid: {
          top: 50, // 图表主体在标题+图例下方
          bottom: 30,
          left: 10,
          right: 20,
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: regions,
            axisPointer: {
              type: 'shadow',
            },
            axisLabel: {
              formatter: (value) => this.isCh(value, 12),
              tooltip: {
                show: true,
                formatter: (params) => params.value, // 悬停显示完整内容
              },
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: '',
            // min: 0,
            // max: 200,
            axisLabel: {
              formatter: (value) => {
                // 核心格式化函数
                if (value >= 1000) {
                  const kValue = value / 1000
                  // 处理小数位显示逻辑
                  return Number.isInteger(kValue) ? `${kValue.toLocaleString()}k` : `${kValue.toFixed(1).toLocaleString()}k`
                }
                return value
              },
            },
          },
          {
            type: 'value',
            name: '',
            // min: 0,
            max: maxValue,
            axisLabel: {
              formatter: '{value} %',
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: '指标',
            type: 'bar',
            data: target,
            itemStyle: {
              color: '#051C20',
            },
            barWidth: '30%',
            label: {
              show: true,
              position: 'top',
              formatter: (params) => {
                return params.value.toLocaleString()
              },
              color: '#333',
              fontSize: this.chart_fontSize,
            },
          },
          {
            name: '日耗用量',
            type: 'bar',
            data: thisYearData,
            itemStyle: {
              color: '#00a8f3',
            },
            barWidth: '30%',
            label: {
              show: true,
              position: 'top',
              formatter: (params) => params.value.toLocaleString(), // 千分位格式化
              color: '#333',
              fontSize: this.chart_fontSize,
            },
          },
          {
            name: '日耗用量达成',
            type: 'line',
            yAxisIndex: 1,
            data: achievementRates,
            markLine: {
              symbol: 'none',
              label: {
                position: 'insideStartTop',
                formatter: '大区平均:{c}%',
                color: '#ff0000',
                fontSize: this.chart_fontSize,
                fontWeight: 'bold',
                distance: [-25, 0],
                // verticalAlign: 'bottom',
              },
              lineStyle: {
                color: '#FF6B6B',
                width: 2,
              },
              data: [
                {
                  yAxis: averageAchieveRate,
                  name: '平均值',
                },
              ],
            },
            itemStyle: {
              color: '#027ab0',
            },
            smooth: false,
            symbol: 'circle',
            symbolSize: 8,
            lineStyle: {
              width: 3,
              type: 'dashed',
            },
            label: {
              show: true,
              position: 'top',
              formatter: (params) => {
                return `${params.value.toLocaleString()}%`
              },
              //   color: '#00a9f4',
              fontWeight: 'bold',
              fontSize: this.chart_fontSize,
            },
          },
          {
            name: '日耗用量增长',
            type: 'line',
            yAxisIndex: 1,
            data: growthRates,
            itemStyle: { color: '#6fd2f1' },
            symbol: 'circle',
            symbolSize: 10,
            lineStyle: {
              width: 3,
              type: 'dashed', // 使用虚线区分
            },
            label: {
              show: true,
              //   position: 'bottom',
              formatter: (params) => {
                const value = params.value.toLocaleString()
                return `${value}%`
              },
              //   color: (params) => (params.value > 0 ? '#67c23a' : '#f56c6c'),
              fontWeight: 'bold',
              fontSize: this.chart_fontSize,
            },
          },
          {
            name: '日耗用量环比',
            type: 'line',
            yAxisIndex: 1,
            data: momGrowthRate,
            itemStyle: { color: '#a4ccd9' },
            symbol: 'circle',
            symbolSize: 10,
            lineStyle: {
              width: 3,
              type: 'dashed', // 使用虚线区分
            },
            label: {
              show: true,
              //   position: 'bottom',
              formatter: (params) => {
                const value = params.value.toLocaleString()
                return `${value}%`
              },
              //   color: (params) => (params.value > 0 ? '#67c23a' : '#f56c6c'),
              fontWeight: 'bold',
              fontSize: this.chart_fontSize,
            },
          },
        ],
      }

      // 设置配置项
      chart.setOption(option, true)
      chart.resize()
    },
    initChart_mtd2(res) {
      var res = this.usagereport_getytdusage_mtd_details
      // 初始化图表
      if (this.isMobile) {
        this.$refs.chartContainer2_mtd.style.width = '600px'
      }
      let chart = echarts.init(this.$refs.chartContainer2_mtd)
      this.charts_list.push(chart)
      const legends = ['指标', '日耗用量', '日耗用量达成', '日耗用量增长', '日耗用量环比']
      const categorys = res.categoryPerformance.map((item) => item.category)
      //   今年
      const thisYearData = res.categoryPerformance.map((item) => item.thisYear)
      //   去年
      const lastYearData = res.categoryPerformance.map((item) => item.lastYear)
      //   指标
      const target = res.categoryPerformance.map((item) => item.target)
      //   完成率
      const achievementRates = res.categoryPerformance.map((item) => item.achievementRate * 100)
      //   增长率
      const growthRates = res.categoryPerformance.map((item) => item.growthRate * 100)
      //   环比
      const momGrowthRate = res.categoryPerformance.map((item) => item.momGrowthRate * 100)
      //   设置series
      let series_list = legends.map((name) => {
        // return {
        //   name: name,
        //   type: 'bar',
        //   itemStyle: itemStyle_cls,
        //   data: res.map((d, did) => {
        //     return d.data[sid].accuracyPercentage
        //   }),
        // }
      })
      // 配置项
      const option = {
        toolbox: {
          show: this.isMobile ? false : true, // 是否显示工具栏
          orient: 'horizontal', // 工具栏布局方向
          itemSize: 15, // 工具栏图标大小
          itemGap: 10, // 工具栏图标间隔
          right: 20, // 工具栏距离右侧的距离
          top: 5, // 工具栏距离顶部的距离
          feature: this.feature_fn(this.$refs.chartContainer2_mtd),
        },
        title: {
          text: '各品类日耗用量达成',
          //   left: 'left',
          fontSize: this.chart_fontSize,
          textStyle: {
            fontSize: window.innerWidth > 768 ? 14 : 14, // 桌面端16px，移动端14px
          },
          top: 5,
        },
        // dataZoom: [
        //   {
        //     type: 'slider',
        //     show: true,
        //     xAxisIndex: [0],
        //     start: 0,
        //     end: 100,
        //   },
        // ],
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'cross' },
          formatter: (params) => {
            let res = `${params[0].name}<br>`
            params.forEach((p) => {
              let value
              if (p.seriesType === 'line') {
                value = `${p.value.toLocaleString(undefined, { maximumFractionDigits: 1 })}%`
              } else {
                value = p.value.toLocaleString()
              }
              res += `${p.marker} ${p.seriesName}: ${value}<br>`
            })
            return res
          },
        },
        legend: {
          data: legends,
          itemWidth: 8, // 缩小图例标记尺寸
          itemHeight: 8,
          textStyle: {
            fontSize: this.chart_fontSize,
          },
          bottom: 0,
        },
        grid: {
          top: 50, // 图表主体在标题+图例下方
          bottom: 30,
          left: 10,
          right: 20,
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: categorys,
            axisPointer: {
              type: 'shadow',
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: '',
            // min: 0,
            // max: 200,
            axisLabel: {
              formatter: (value) => {
                // 核心格式化函数
                if (value >= 1000) {
                  const kValue = value / 1000
                  // 处理小数位显示逻辑
                  return Number.isInteger(kValue) ? `${kValue.toLocaleString()}k` : `${kValue.toFixed(1).toLocaleString()}k`
                }
                return value
              },
            },
          },
          {
            type: 'value',
            name: '',
            // min: 0,
            // max: 100,
            axisLabel: {
              formatter: '{value} %',
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: '指标',
            type: 'bar',
            data: target,
            itemStyle: {
              color: '#051C20',
            },
            barWidth: '30%',
            label: {
              show: true,
              position: 'top',
              formatter: (params) => {
                return params.value.toLocaleString()
              },
              color: '#333',
              fontSize: this.chart_fontSize,
            },
          },
          {
            name: '日耗用量',
            type: 'bar',
            data: thisYearData,
            itemStyle: {
              color: '#00a8f3',
            },
            barWidth: '30%',
            label: {
              show: true,
              position: 'top',
              formatter: (params) => params.value.toLocaleString(), // 千分位格式化
              color: '#333',
              fontSize: this.chart_fontSize,
            },
          },
          {
            name: '日耗用量达成',
            type: 'line',
            yAxisIndex: 1,
            data: achievementRates,
            itemStyle: {
              color: '#027ab0',
            },
            smooth: false,
            symbol: 'circle',
            symbolSize: 8,
            lineStyle: {
              width: 3,
              type: 'dashed',
            },
            label: {
              show: true,
              position: 'top',
              formatter: (params) => {
                return `${params.value.toLocaleString()}%`
              },
              //   color: '#00a9f4',
              fontWeight: 'bold',
              fontSize: this.chart_fontSize,
            },
          },
          {
            name: '日耗用量增长',
            type: 'line',
            yAxisIndex: 1,
            data: growthRates,
            itemStyle: { color: '#6fd2f1' },
            symbol: 'circle',
            symbolSize: 10,
            lineStyle: {
              width: 3,
              type: 'dashed', // 使用虚线区分
            },
            label: {
              show: true,
              //   position: 'bottom',
              formatter: (params) => {
                const value = params.value.toLocaleString()
                return `${value}%`
              },
              //   color: (params) => (params.value > 0 ? '#67c23a' : '#f56c6c'),
              fontWeight: 'bold',
              fontSize: this.chart_fontSize,
            },
          },
          {
            name: '日耗用量环比',
            type: 'line',
            yAxisIndex: 1,
            data: momGrowthRate,
            itemStyle: { color: '#a4ccd9' },
            symbol: 'circle',
            symbolSize: 10,
            lineStyle: {
              width: 3,
              type: 'dashed', // 使用虚线区分
            },
            label: {
              show: true,
              //   position: 'bottom',
              formatter: (params) => {
                const value = params.value.toLocaleString()
                return `${value}%`
              },
              //   color: (params) => (params.value > 0 ? '#67c23a' : '#f56c6c'),
              fontWeight: 'bold',
              fontSize: this.chart_fontSize,
            },
          },
        ],
      }

      // 设置配置项
      chart.setOption(option, true)
    },
    initChart_mtd3(res) {
      var res = this.usagereport_getytdusage_mtd_details.dailyProductPerformance
      const monthName = res.dailyProductPerformance.map((item) => item.date)
      if (this.isMobile) {
        if (monthName.length > 6) {
          this.$refs.chartContainer3_mtd.style.width = '1000px'
        } else {
          this.$refs.chartContainer3_mtd.style.width = '600px'
        }
      }
      // 初始化图表
      let chart = echarts.init(this.$refs.chartContainer3_mtd)
      this.charts_list.push(chart)
      //   var items_color = ['#051C20', '#024c6f', '#017aaf', '#00a9f4', '#6fd2f1', '#a4ccd9', '#b3bac2']
      //   var items_color = ['#b3bac2', '#a4ccd9', '#6fd2f1', '#00a9f4', '#017aaf', '#024c6f', '#061b2c']
      var items_color = ['#034c6c', '#034c6c', '#5aa2ae', '#bfbfbf', '#02a8ee', '#02a8ee', '#02a8ee']

      const categoryValues_name = res.dailyProductPerformance[0].productPerformances.map((item) => item.productCode)
      const dayMax = res.dailyProductPerformance.dayMax
      const averageAchieveRate = res.dailyProductPerformance.averageAchieveRate
      const maxValue = dayMax > averageAchieveRate ? null : averageAchieveRate
      const series = categoryValues_name.map((name, sid) => {
        return {
          name,
          type: 'bar',
          stack: 'total',
          barWidth: '60%',
          itemStyle: {
            color: items_color[sid],
          },
          markLine: {
            symbol: 'none',
            label: {
              show: sid == 0 ? true : false,
              position: 'insideStartTop',
              left: 20,
              //   formatter: '{c}',
              color: '#ff0000',
              fontSize: this.chart_fontSize,
              fontWeight: 'bold',
              formatter: (params) => {
                return '区域平均:' + params.value.toLocaleString()
              },
              distance: [-25, 0],
              // verticalAlign: 'bottom',
            },
            lineStyle: {
              color: '#FF6B6B',
              width: 2,
            },
            data: [
              {
                yAxis: res.averageAchieveRate,
                name: '平均值',
              },
            ],
          },
          label: {
            // color: '#333',
            show: true,
            formatter: (params) => {
              if (params.value === 0) {
                return ''
              }
              //   return params.value.toLocaleString() // 千分位格式化
              return params.seriesName
            },
            // fontWeight: 'bold',
            fontSize: this.chart_fontSize - 2,
          },
          data: res.dailyProductPerformance.map((d, did) => {
            return d.productPerformances[sid].total
          }),
        }
      })
      const option = {
        toolbox: {
          show: this.isMobile ? false : true, // 是否显示工具栏
          orient: 'horizontal', // 工具栏布局方向
          itemSize: 15, // 工具栏图标大小
          itemGap: 10, // 工具栏图标间隔
          right: 20, // 工具栏距离右侧的距离
          top: 5, // 工具栏距离顶部的距离
          feature: this.feature_fn(this.$refs.chartContainer3_mtd),
        },
        title: {
          text: '各品类日耗用量趋势',
          //   left: 'left',
          fontSize: this.chart_fontSize,
          textStyle: {
            fontSize: window.innerWidth > 768 ? 14 : 14, // 桌面端16px，移动端14px
          },
          top: 5,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'cross' },
          formatter: (params) => {
            var params = params.reverse()
            let res = `${params[0].name}<br>`
            params.forEach((p) => {
              let value
              value = p.value.toLocaleString()
              res += `${p.marker} ${p.seriesName}: ${value}<br>`
            })
            return res
          },
        },
        legend: {
          show: true,
          data: categoryValues_name,
          itemWidth: 8, // 缩小图例标记尺寸
          itemHeight: 8,
          textStyle: {
            fontSize: this.chart_fontSize,
          },
          bottom: 0,
        },
        grid: {
          top: 50, // 图表主体在标题+图例下方
          bottom: this.isMobile ? 50 : 30,
          left: 10,
          right: 20,
          containLabel: true,
        },
        yAxis: {
          type: 'value',
          //   max: maxValue,
          axisLabel: {
            formatter: (value) => {
              // 核心格式化函数
              if (value >= 1000) {
                const kValue = value / 1000
                // 处理小数位显示逻辑
                return Number.isInteger(kValue) ? `${kValue.toLocaleString()}k` : `${kValue.toFixed(1).toLocaleString()}k`
              }
              return value
            },
          },
        },
        xAxis: {
          type: 'category',
          data: monthName,
        },
        series,
      }
      // 设置配置项
      chart.setOption(option, true)
    },
    initChart(res) {
      // 初始化图表
      var res = this.usagereport_getytdusage_ytd_details.regionPerformance
      const regions = res.regionPerformance.map((item) => item.region)
      console.log(regions)
      if (this.isMobile) {
        if (regions.length > 6) {
          this.ytd_widths = '1500px'
        } else {
          this.ytd_widths = '600px'
        }
      } else {
        this.ytd_widths = regions.length > 6 ? '1500px' : '100%'
      }
      this.$refs.chartContainer.style.width = this.ytd_widths
      let chart = echarts.init(this.$refs.chartContainer)
      this.charts_list.push(chart)
      console.log(this.charts_list)
      const legends = ['指标', '日耗用量', '日耗用量达成', '日耗用量增长']
      //   今年
      const thisYearData = res.regionPerformance.map((item) => item.thisYear)
      //   去年
      const lastYearData = res.regionPerformance.map((item) => item.lastYear)
      //   指标
      const target = res.regionPerformance.map((item) => item.target)
      //   完成率
      const achievementRates = res.regionPerformance.map((item) => item.achievementRate * 100)
      //   增长率
      const growthRates = res.regionPerformance.map((item) => item.growthRate * 100)
      //   计算y轴max值
      const MathachievementRates = Math.max(...achievementRates)
      const averageAchieveRate = (res.averageAchieveRate * 100).toFixed(0)
      const maxValue = MathachievementRates > averageAchieveRate ? null : averageAchieveRate
      //   设置series
      let series_list = legends.map((name) => {
        // return {
        //   name: name,
        //   type: 'bar',
        //   itemStyle: itemStyle_cls,
        //   data: res.map((d, did) => {
        //     return d.data[sid].accuracyPercentage
        //   }),
        // }
      })
      // 配置项
      const option = {
        toolbox: {
          show: this.isMobile ? false : true, // 是否显示工具栏
          orient: 'horizontal', // 工具栏布局方向
          itemSize: 15, // 工具栏图标大小
          itemGap: 10, // 工具栏图标间隔
          right: 20, // 工具栏距离右侧的距离
          top: 5, // 工具栏距离顶部的距离
          feature: this.feature_fn(this.$refs.chartContainer),
        },
        title: {
          text: '日耗用量达成',
          //   left: 'left',
          textStyle: {
            fontSize: window.innerWidth > 768 ? 14 : 14, // 桌面端16px，移动端14px
          },
          top: 5,
        },
        // dataZoom: [
        //   {
        //     type: 'slider',
        //     show: true,
        //     // xAxisIndex: [0],
        //     start: 0,
        //     end: 100,
        //     height: 10, // 组件高度
        //     bottom: 10,
        //   },
        //   {
        //     type: 'inside', // 内置型数据缩放
        //     zoomLock: true, // 锁定缩放比例
        //     zoomOnMouseWheel: 'shift', // 按住shift滚轮缩放
        //   },
        // ],
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'cross' },
          formatter: (params) => {
            let res = `${params[0].name}<br>`
            params.forEach((p) => {
              let value
              if (p.seriesType === 'line') {
                value = `${p.value.toLocaleString(undefined, { maximumFractionDigits: 1 })}%`
              } else {
                value = p.value.toLocaleString()
              }
              res += `${p.marker} ${p.seriesName}: ${value}<br>`
            })
            return res
          },
        },
        legend: {
          data: legends,
          itemWidth: 8, // 缩小图例标记尺寸
          itemHeight: 8,
          textStyle: {
            fontSize: this.chart_fontSize,
          },
          bottom: 0,
        },
        grid: {
          top: 50, // 图表主体在标题+图例下方
          bottom: 30,
          left: 10,
          right: 20,
          containLabel: true,
        },
        // dataZoom: [
        //   {
        //     type: 'slider',
        //     show: regions.length > 6 ? true : false,
        //     xAxisIndex: 0,
        //     start: 0,
        //     end: regions.length > 6 ? 30 : 100, // 初始显示50%数据
        //     height: 5, // 组件高度
        //     bottom: 25, // 组件位置
        //     handleSize: '80%', // 手柄大小
        //   },
        // ],
        xAxis: [
          {
            type: 'category',
            data: regions,
            axisPointer: {
              type: 'shadow',
            },
            axisLabel: {
              formatter: (value) => this.isCh(value, 12),
              tooltip: {
                show: true,
                formatter: (params) => params.value, // 悬停显示完整内容
              },
            },
            // axisLabel: {
            //   margin: 15, // 标签与轴线间距（默认8px）
            // },
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: '',
            // min: 0,
            // max: 200,
            axisLabel: {
              formatter: (value) => {
                // 核心格式化函数
                if (value >= 1000) {
                  const kValue = value / 1000
                  // 处理小数位显示逻辑
                  return Number.isInteger(kValue) ? `${kValue.toLocaleString()}k` : `${kValue.toFixed(1).toLocaleString()}k`
                }
                return value
              },
            },
          },
          {
            type: 'value',
            name: '',
            // min: 0,
            max: maxValue,
            axisLabel: {
              formatter: '{value} %',
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: '指标',
            type: 'bar',
            data: target,
            itemStyle: {
              color: '#051C20',
            },
            barWidth: '30%',
            label: {
              show: true,
              position: 'top',
              formatter: (params) => {
                return params.value.toLocaleString()
              },
              color: '#333',
              fontSize: this.chart_fontSize,
            },
          },
          {
            name: '日耗用量',
            type: 'bar',
            data: thisYearData,
            itemStyle: {
              color: '#00a8f3',
            },
            barWidth: '30%',
            label: {
              show: true,
              position: 'top',
              formatter: (params) => params.value.toLocaleString(), // 千分位格式化
              color: '#333',
              fontSize: this.chart_fontSize,
            },
          },
          {
            name: '日耗用量达成',
            type: 'line',
            yAxisIndex: 1,
            data: achievementRates,
            itemStyle: {
              color: '#027ab0',
            },
            markLine: {
              symbol: 'none',
              label: {
                position: 'insideStartTop',
                formatter: '大区平均:{c}%',
                color: '#ff0000',
                fontSize: this.chart_fontSize,
                fontWeight: 'bold',
                distance: [-25, 0],
                // verticalAlign: 'bottom',
              },
              lineStyle: {
                color: '#FF6B6B',
                width: 2,
              },
              data: [
                {
                  yAxis: averageAchieveRate,
                  name: '平均值',
                },
              ],
            },
            smooth: false,
            symbol: 'circle',
            symbolSize: 8,
            lineStyle: {
              width: 3,
              type: 'dashed',
            },
            label: {
              show: true,
              position: 'top',
              formatter: (params) => {
                return `${params.value.toLocaleString()}%`
              },
              //   color: '#00a9f4',
              fontWeight: 'bold',
              fontSize: this.chart_fontSize,
            },
          },
          {
            name: '日耗用量增长',
            type: 'line',
            yAxisIndex: 1,
            data: growthRates,
            itemStyle: { color: '#6fd2f1' },
            symbol: 'circle',
            symbolSize: 10,
            lineStyle: {
              width: 3,
              type: 'dashed', // 使用虚线区分
            },
            label: {
              show: true,
              //   position: 'bottom',
              formatter: (params) => {
                const value = params.value.toLocaleString()
                return `${value}%`
              },
              //   color: (params) => (params.value > 0 ? '#67c23a' : '#f56c6c'),
              fontWeight: 'bold',
              fontSize: this.chart_fontSize,
            },
          },
        ],
      }
      // 设置配置项
      chart.setOption(option, true)
      // setTimeout(() => {
      chart.resize()
      // }, 500)
    },
    initChart2(res) {
      // 初始化图表
      if (this.isMobile) {
        this.$refs.chartContainer2.style.width = '600px'
      }
      let chart = echarts.init(this.$refs.chartContainer2)
      this.charts_list.push(chart)
      var res = this.usagereport_getytdusage_ytd_details
      const legends = ['指标', '日耗用量', '日耗用量达成', '日耗用量增长']
      const categorys = res.categoryPerformance.map((item) => item.category)
      //   今年
      const thisYearData = res.categoryPerformance.map((item) => item.thisYear)
      //   去年
      const lastYearData = res.categoryPerformance.map((item) => item.lastYear)
      //   指标
      const target = res.categoryPerformance.map((item) => item.target)
      //   完成率
      const achievementRates = res.categoryPerformance.map((item) => item.achievementRate * 100)
      //   增长率
      const growthRates = res.categoryPerformance.map((item) => item.growthRate * 100)
      //   设置series
      let series_list = legends.map((name) => {
        // return {
        //   name: name,
        //   type: 'bar',
        //   itemStyle: itemStyle_cls,
        //   data: res.map((d, did) => {
        //     return d.data[sid].accuracyPercentage
        //   }),
        // }
      })
      // 配置项
      const option = {
        toolbox: {
          show: this.isMobile ? false : true, // 是否显示工具栏
          orient: 'horizontal', // 工具栏布局方向
          itemSize: 15, // 工具栏图标大小
          itemGap: 10, // 工具栏图标间隔
          right: 20, // 工具栏距离右侧的距离
          top: 5, // 工具栏距离顶部的距离
          feature: this.feature_fn(this.$refs.chartContainer2),
        },
        title: {
          text: '各品类日耗用量达成',
          //   left: 'left',
          textStyle: {
            fontSize: window.innerWidth > 768 ? 14 : 14, // 桌面端16px，移动端14px
          },
          top: 5,
        },
        // dataZoom: [
        //   {
        //     type: 'slider',
        //     show: true,
        //     xAxisIndex: [0],
        //     start: 0,
        //     end: 100,
        //   },
        // ],
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'cross' },
          formatter: (params) => {
            let res = `${params[0].name}<br>`
            params.forEach((p) => {
              let value
              if (p.seriesType === 'line') {
                value = `${p.value.toLocaleString(undefined, { maximumFractionDigits: 1 })}%`
              } else {
                value = p.value.toLocaleString()
              }
              res += `${p.marker} ${p.seriesName}: ${value}<br>`
            })
            return res
          },
        },
        legend: {
          data: legends,
          itemWidth: 8, // 缩小图例标记尺寸
          itemHeight: 8,
          textStyle: {
            fontSize: this.chart_fontSize,
          },
          bottom: 0,
        },
        grid: {
          top: 50, // 图表主体在标题+图例下方
          bottom: 30,
          left: 10,
          right: 20,
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: categorys,
            axisPointer: {
              type: 'shadow',
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: '',
            // min: 0,
            // max: 200,
            axisLabel: {
              formatter: (value) => {
                // 核心格式化函数
                if (value >= 1000) {
                  const kValue = value / 1000
                  // 处理小数位显示逻辑
                  return Number.isInteger(kValue) ? `${kValue.toLocaleString()}k` : `${kValue.toFixed(1).toLocaleString()}k`
                }
                return value
              },
            },
          },
          {
            type: 'value',
            name: '',
            // min: 0,
            // max: 100,
            axisLabel: {
              formatter: '{value} %',
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: '指标',
            type: 'bar',
            data: target,
            itemStyle: {
              color: '#051C20',
            },
            barWidth: '30%',
            label: {
              show: true,
              position: 'top',
              formatter: (params) => {
                return params.value.toLocaleString()
              },
              color: '#333',
              fontSize: this.chart_fontSize,
            },
          },
          {
            name: '日耗用量',
            type: 'bar',
            data: thisYearData,
            itemStyle: {
              color: '#00a8f3',
            },
            barWidth: '30%',
            label: {
              show: true,
              position: 'top',
              formatter: (params) => params.value.toLocaleString(), // 千分位格式化
              color: '#333',
              fontSize: this.chart_fontSize,
            },
          },
          {
            name: '日耗用量达成',
            type: 'line',
            yAxisIndex: 1,
            data: achievementRates,
            itemStyle: {
              color: '#027ab0',
            },
            smooth: false,
            symbol: 'circle',
            symbolSize: 8,
            lineStyle: {
              width: 3,
              type: 'dashed',
            },
            label: {
              show: true,
              position: 'top',
              formatter: (params) => {
                return `${params.value.toLocaleString()}%`
              },
              //   color: '#00a9f4',
              fontWeight: 'bold',
              fontSize: this.chart_fontSize,
            },
          },
          {
            name: '日耗用量增长',
            type: 'line',
            yAxisIndex: 1,
            data: growthRates,
            itemStyle: { color: '#6fd2f1' },
            symbol: 'circle',
            symbolSize: 10,
            lineStyle: {
              width: 3,
              type: 'dashed', // 使用虚线区分
            },
            label: {
              show: true,
              //   position: 'bottom',
              formatter: (params) => {
                const value = params.value.toLocaleString()
                return `${value}%`
              },
              //   color: (params) => (params.value > 0 ? '#67c23a' : '#f56c6c'),
              fontWeight: 'bold',
              fontSize: this.chart_fontSize,
            },
          },
        ],
      }

      // 设置配置项
      chart.setOption(option, true)
    },
    initChart3(res) {
      var res = this.usagereport_getytdusage_ytd_details
      if (this.isMobile) {
        this.$refs.chartContainer3.style.width = '600px'
      }
      // 初始化图表
      let chart = echarts.init(this.$refs.chartContainer3)
      this.charts_list.push(chart)
      const legends = ['指标', '日耗用量', '日耗用量达成', '日耗用量增长']
      const categorys = res.monthlyPerformance.map((item) => item.monthName)
      //   今年
      const thisYearData = res.monthlyPerformance.map((item) => item.thisMonth)
      //   去年
      const lastYearData = res.monthlyPerformance.map((item) => item.lastMonth)
      //   指标
      const target = res.monthlyPerformance.map((item) => item.target)
      //   完成率
      const achievementRates = res.monthlyPerformance.map((item) => item.achievementRate * 100)
      //   增长率
      const growthRates = res.monthlyPerformance.map((item) => item.growthRate * 100)
      //   设置series
      let series_list = legends.map((name) => {
        // return {
        //   name: name,
        //   type: 'bar',
        //   itemStyle: itemStyle_cls,
        //   data: res.map((d, did) => {
        //     return d.data[sid].accuracyPercentage
        //   }),
        // }
      })
      // 配置项
      const option = {
        toolbox: {
          show: this.isMobile ? false : true, // 是否显示工具栏
          orient: 'horizontal', // 工具栏布局方向
          itemSize: 15, // 工具栏图标大小
          itemGap: 10, // 工具栏图标间隔
          right: 20, // 工具栏距离右侧的距离
          top: 5, // 工具栏距离顶部的距离
          feature: this.feature_fn(this.$refs.chartContainer3),
        },
        title: {
          text: '各月日耗用量达成',
          //   left: 'left',
          fontSize: this.chart_fontSize,
          textStyle: {
            fontSize: window.innerWidth > 768 ? 14 : 14, // 桌面端16px，移动端14px
          },
          top: 5,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'cross' },
          formatter: (params) => {
            let res = `${params[0].name}<br>`
            params.forEach((p) => {
              let value
              if (p.seriesType === 'line') {
                value = `${p.value.toLocaleString(undefined, { maximumFractionDigits: 1 })}%`
              } else {
                value = p.value.toLocaleString()
              }
              res += `${p.marker} ${p.seriesName}: ${value}<br>`
            })
            return res
          },
        },
        legend: {
          data: legends,
          itemWidth: 8, // 缩小图例标记尺寸
          itemHeight: 8,
          textStyle: {
            fontSize: this.chart_fontSize,
          },
          bottom: 0,
        },
        grid: {
          top: 50, // 图表主体在标题+图例下方
          bottom: this.isMobile ? 30 : 40,
          left: 10,
          right: 20,
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: categorys,
            axisPointer: {
              type: 'shadow',
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: '',
            // min: 0,
            // max: 200,
            axisLabel: {
              formatter: (value) => {
                if (value >= 1000) {
                  const kValue = value / 1000
                  // 处理小数位显示逻辑
                  return Number.isInteger(kValue) ? `${kValue.toLocaleString()}k` : `${kValue.toFixed(1).toLocaleString()}k`
                }
                return value
              },
            },
          },
          {
            type: 'value',
            name: '',
            // min: 0,
            // max: 100,
            axisLabel: {
              formatter: '{value} %',
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: '指标',
            type: 'bar',
            data: target,
            itemStyle: {
              color: '#051C20',
            },
            barWidth: '30%',
            label: {
              show: true,
              position: 'top',
              formatter: (params) => {
                return params.value.toLocaleString()
              },
              color: '#333',
              fontSize: this.chart_fontSize,
            },
          },
          {
            name: '日耗用量',
            type: 'bar',
            data: thisYearData,
            itemStyle: {
              color: '#00a8f3',
            },
            barWidth: '30%',
            label: {
              show: true,
              position: 'top',
              formatter: (params) => params.value.toLocaleString(), // 千分位格式化
              color: '#333',
              fontSize: this.chart_fontSize,
            },
          },
          {
            name: '日耗用量达成',
            type: 'line',
            yAxisIndex: 1,
            data: achievementRates,
            itemStyle: {
              color: '#027ab0',
            },
            smooth: false,
            symbol: 'circle',
            symbolSize: 8,
            lineStyle: {
              width: 3,
              type: 'dashed',
            },
            label: {
              show: true,
              position: 'top',
              formatter: (params) => {
                return `${params.value.toLocaleString()}%`
              },
              fontWeight: 'bold',
              fontSize: this.chart_fontSize,
            },
          },
          {
            name: '日耗用量增长',
            type: 'line',
            yAxisIndex: 1,
            data: growthRates,
            itemStyle: { color: '#6fd2f1' },
            symbol: 'circle',
            symbolSize: 10,
            lineStyle: {
              width: 3,
              type: 'dashed', // 使用虚线区分
            },
            label: {
              show: true,
              //   position: 'bottom',
              formatter: (params) => {
                const value = params.value.toLocaleString()
                return `${value}%`
              },
              fontWeight: 'bold',
              fontSize: this.chart_fontSize,
            },
          },
        ],
      }

      // 设置配置项
      chart.setOption(option, true)
    },
    initChart4(res) {
      var res = this.usagereport_getytdusage_ytd_details
      if (this.isMobile) {
        this.$refs.chartContainer4.style.width = '600px'
      }
      // 初始化图表
      let chart = echarts.init(this.$refs.chartContainer4)
      this.charts_list.push(chart)
      //   const legends = ['指标', '日耗用量', '日耗用量达成', '日耗用量增长']
      //   var items_color = ['#02a8ee', '#02a8ee', '#02a8ee', '#bfbfbf', '#5aa2ae', '#034c6c', '#034c6c']
      var items_color = ['#034c6c', '#034c6c', '#5aa2ae', '#bfbfbf', '#02a8ee', '#02a8ee', '#02a8ee']
      const monthName = res.monthlyCategoryTrend.map((item) => item.name)
      const categoryValues_name = res.monthlyCategoryTrend[0].categoryGroups.map((item) => item.name)
      var monthlyCategoryTrend = res.monthlyCategoryTrend
      const categoryValues_name_list = res.monthlyCategoryTrend[0].categoryGroups
      const categories = res.monthlyCategoryTrend[0].categoryGroups.map((item) => item.productName)
      const uniqueArray = categories.filter((value, index, self) => {
        return self.indexOf(value) === index
      })
      //    ['PC', 'TORIC', 'MONO']
      const xAxisData = []
      monthName.forEach((month) => {
        uniqueArray.forEach((cat) => {
          xAxisData.push(`${month}-${cat}`)
        })
      })

      const series = categoryValues_name_list.map((res, sid) => {
        return {
          name: res.name,
          type: 'bar',
          //   stack: res.productName,
          stack: 'bars',
          barWidth: '25%',
          //   barCategoryGap: '20px',
          itemStyle: {
            color: items_color[sid],
          },
          label: {
            // color: '#333',
            show: true,
            formatter: (params) => {
              console.log(params)
              if (params.value === 0) {
                return ''
              }
              //   return params.value.toLocaleString() // 千分位格式化
              return params.seriesName
            },
            // fontWeight: 'bold',
            fontSize: this.chart_fontSize - 2,
          },
          data: monthlyCategoryTrend.map((d, did) => {
            return d.categoryGroups[sid].value
          }),
        }
      })
      const option = {
        toolbox: {
          show: this.isMobile ? false : true, // 是否显示工具栏
          orient: 'horizontal', // 工具栏布局方向
          itemSize: 15, // 工具栏图标大小
          itemGap: 10, // 工具栏图标间隔
          right: 20, // 工具栏距离右侧的距离
          top: 5, // 工具栏距离顶部的距离
          feature: this.feature_fn(this.$refs.chartContainer4),
        },
        title: {
          text: '各品类日耗用量趋势',
          //   left: 'left',
          textStyle: {
            fontSize: window.innerWidth > 768 ? 14 : 14, // 桌面端16px，移动端14px
          },
          top: 5,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'cross' },
          formatter: (params) => {
            var params = params.reverse()
            let res = `${params[0].name}<br>`
            params.forEach((p) => {
              let value
              value = p.value.toLocaleString()
              res += `${p.marker} ${p.seriesName}: ${value}<br>`
            })
            console.log(res)
            return res
          },
        },
        legend: {
          show: true,
          data: categoryValues_name,
          itemWidth: 8, // 缩小图例标记尺寸
          itemHeight: 8,
          textStyle: {
            fontSize: this.chart_fontSize,
          },
          //   left: 0,
          //   selectedMode: false,
          bottom: 0,
        },
        grid: {
          top: 50, // 图表主体在标题+图例下方
          bottom: this.isMobile ? 50 : 40,
          left: 10,
          right: 20,
          containLabel: true,
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: (value) => {
              // 核心格式化函数
              if (value >= 1000) {
                const kValue = value / 1000
                // 处理小数位显示逻辑
                return Number.isInteger(kValue) ? `${kValue.toLocaleString()}k` : `${kValue.toFixed(1).toLocaleString()}k`
              }
              return value
            },
          },
        },
        xAxis: {
          type: 'category',
          data: monthName,
        },
        series,
      }
      // 设置配置项
      chart.setOption(option, true)
    },
    isCh(n, l) {
      var length = l
      var len = 0
      for (var i = 0; i < n.length; i++) {
        var c = n.charCodeAt(i)
        //单字节加1
        if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
          len++
        } else {
          len += 2
        }
        if (len >= length) {
          var m = n.slice(0, i + 1) + '…'
          return m
        }
      }
      return n
    },
    // 防抖动
    debounce(fn, delay) {
      let timer = null
      return function (...args) {
        if (timer) clearTimeout(timer)
        timer = setTimeout(() => {
          fn.apply(this, args)
        }, delay)
      }
    },
    // 响应视觉窗口变化调整图表大小
    resizeHandler() {
      let resizeHandler = this.debounce(() => {
        this.charts_list.forEach((chart) => {
          chart.resize()
        })
      }, 300)
      window.addEventListener('resize', resizeHandler)
    },
    // 销毁图表实例
    beforeDestroy() {
      window.removeEventListener('resize', this.resizeHandler)
      this.charts_list.forEach((chart) => chart.dispose())
    },
    // handleResize() {
    //   this.chart && this.chart.resize()
    // },
    async system_getproductlistothers_fn() {
      const { data } = await system_getproductlistothers()
      this.product_List = data.data
    },
    getReportData(res) {
      if (this.area_list.length == 1) {
        console.log(this.area_list)
      }
      var un = Number(this.activeName)
      switch (un) {
        case 1:
          this.filters = res
          this.usagereport_getytdusage_ytd_fn()
          break
        case 2:
          this.filters_mtd = res
          this.usagereport_getytdusage_mtd_fn()
          break
        case 3:
          this.filters_day = res
          this.usagereport_getdailyusage_day_fn()
          break
      }
    },
    handleClick(tab, event) {
      if (this.activeName_if == tab.name) return
      this.activeName_if = tab.name
      this.beforeDestroy()
    },
    onFullScreenChange() {
      if (document.fullscreenElement) {
        this.chart_fontSize = 12
        // 这里可以执行进入全屏后的操作
      } else {
        this.chart_fontSize = 8
        // 这里可以执行退出全屏后的操作
      }
      var un = Number(this.activeName)
      switch (un) {
        case 1:
          this.initChart()
          this.initChart2()
          this.initChart3()
          this.initChart4()
          break
        case 2:
          this.initChart_mtd()
          this.initChart_mtd2()
          this.initChart_mtd3()
          break
        case 3:
          this.initChart_day()
          this.initChart_day2()
          this.initChart_day3()
          break
      }
    },
  },
  mounted() {
    document.addEventListener('fullscreenchange', this.onFullScreenChange)
    document.addEventListener('webkitfullscreenchange', this.onFullScreenChange)
    document.addEventListener('mozfullscreenchange', this.onFullScreenChange)
    document.addEventListener('MSFullscreenChange', this.onFullScreenChange)
    window.addEventListener('resize', this.resizeHandler())
    this.dashboard_getregionsbylevel()
    this.extapi_dashboard_get_fn()
    this.system_getproductlistothers_fn()
    this.isMobile = window.innerWidth <= 475
    let tokenStr = window.localStorage.Token
    this.token = {
      Authorization: 'Bearer ' + tokenStr,
    }
  },
}
</script>
<style>
.chart_div {
  width: 100%;
  height: 300px;
  background: white;
}
.card_cls .el-card__body {
  padding: 5px !important;
}
.card_cls_mb {
  margin-bottom: 5px;
}
.card_cls div {
  text-align: center;
}
.el-tabs__item {
  font-size: 13px !important;
}
.el-tabs__header {
  margin: 0 0 5px !important;
}
.reports .cell {
  padding: 0 !important;
  font-size: 12px;
}
.reports td.el-table__cell {
  padding: 0 !important;
}
</style>
